import dayjs from 'dayjs';

/**
 * Wiek w pełnych latach na dzień odniesienia (np. pierwszy dzień turnusu).
 * Daty ISO (`YYYY-MM-DD`) podajemy stringiem i parsujemy przez `dayjs`, żeby
 * nie wpaść w interpretację UTC, jaką `new Date('2019-11-09')` narzuca datom
 * bez strefy.
 */
export const calculateAge = (
  birthDate: Date | string,
  referenceDate: Date | string,
): number => dayjs(referenceDate).diff(dayjs(birthDate), 'year');
